import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showFilter: '=',
        list: '=',
        filter: '=',
        defaultFilter: '=',
        classifiers: '='
    },
    template: `
        <form ng-submit="vm.submitFilter()">
            <div class="form form-filter" ng-if="vm.showFilter===true">
                <div class="fields">
                    <div class="row row-md">
                        <label class="label">{{ 'performanceReview.Employee name' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedEmployee"
                                ng-model="vm.filter.userName"
                                value-attribute="'displayName'"
                                placeholder="vm.$translate.instant('filter.Find an employee')"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.siteSelect.options"
                                selected-model="vm.multiFilter.siteSelect.models"
                                extra-settings="vm.multiFilter.siteSelect.settings"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'courses.Department' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                ng-if="vm.FilterService.toggleDepartment"
                                options="vm.FilterService.departmentSelect.options"
                                selected-model="vm.FilterService.departmentSelect.models"
                                extra-settings="vm.FilterService.departmentSelect.settings"
                                events="vm.FilterService.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                            <div ng-dropdown-multiselect=""
                                ng-if="!vm.FilterService.toggleDepartment"
                                options="vm.FilterService.departmentSelect.options"
                                selected-model="vm.FilterService.departmentSelect.models"
                                extra-settings="vm.FilterService.departmentSelect.settings"
                                events="vm.FilterService.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'courses.Role' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                ng-if="vm.FilterService.toggleRole"
                                options="vm.FilterService.roleSelect.options"
                                selected-model="vm.FilterService.roleSelect.models"
                                extra-settings="vm.FilterService.roleSelect.settings"
                                events="vm.FilterService.roleSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                            <div ng-dropdown-multiselect=""
                                ng-if="!vm.FilterService.toggleRole"
                                options="vm.FilterService.roleSelect.options"
                                selected-model="vm.FilterService.roleSelect.models"
                                extra-settings="vm.FilterService.roleSelect.settings"
                                events="vm.FilterService.roleSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'courses.Level' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                ng-if="vm.FilterService.toggleLevel"
                                options="vm.FilterService.levelSelect.options"
                                selected-model="vm.FilterService.levelSelect.models"
                                extra-settings="vm.FilterService.levelSelect.settings"
                                events="vm.FilterService.levelSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                            <div ng-dropdown-multiselect=""
                                ng-if="!vm.FilterService.toggleLevel"
                                options="vm.FilterService.levelSelect.options"
                                selected-model="vm.FilterService.levelSelect.models"
                                extra-settings="vm.FilterService.levelSelect.settings"
                                events="vm.FilterService.levelSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Employee status' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.employeeStatusesSelect.options"
                                selected-model="vm.multiFilter.employeeStatusesSelect.models"
                                extra-settings="vm.multiFilter.employeeStatusesSelect.settings"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Direct manager' | translate }}</label>
                        <div class="items">
                            <div class="items">
                                <autocomplete
                                    label-attribute="'displayName'"
                                    selected-item="vm.selectedManager"
                                    ng-model="vm.filter.managerId"
                                    value-attribute="'id'"
                                    placeholder="vm.$translate.instant('filter.Find a manager')"
                                    query="vm.queryManagers(input)"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'performanceReview.Interview status' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.status"
                                ng-options="status.KEY as status.LABEL for status in vm.statuses">
                            <option value=""></option>
                            </select>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </div>
        </form>
    `
})
export default class {
    constructor ($translate, SiteService, FilterService, UserResource, lodash,
                 ROLE_COMPANY_MODULE_PRIVILEGE_ENUM, ROLE_CODE_ENUM, REVIEW_STATUS_ENUM,
                 ROLE_PRIVILEGE_ENUM, CLASSIFIER_ENUM, USER_STATUS_ENUM) {
        this.$translate = $translate;
        this.SiteService = SiteService;
        this.FilterService = FilterService;
        this.UserResource = UserResource;
        this.lodash = lodash;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.statuses = REVIEW_STATUS_ENUM.KEY_LABEL_PAIRS;
    }

    $onInit () {
        this.filters = false;
        this.sites = this.SiteService.getSitesByPrivileges([
            this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.PERFORMANCE_REVIEW_MANAGE
        ]);

        this.filterTranslations = this.FilterService.getTranslations();
        this.initMultiFilter();
    }

    initMultiFilter () {
        this.FilterService.init(this.classifiers);

        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });

        const statusOptions = [
            { value: this.USER_STATUS_ENUM.KEYS.ACTIVE, label: this.USER_STATUS_ENUM.LABELS.ACTIVE },
            { value: this.USER_STATUS_ENUM.KEYS.INACTIVE, label: this.USER_STATUS_ENUM.LABELS.INACTIVE },
            { value: this.USER_STATUS_ENUM.KEYS.NOT_STARTED, label: this.USER_STATUS_ENUM.LABELS.NOT_STARTED }
        ];
        const statusOptionsSelected = [statusOptions[0], statusOptions[2]];

        this.multiFilter = {
            employeeStatusesSelect: {
                models: statusOptionsSelected,
                options: statusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            siteSelect: {
                models: this.lodash.clone(siteOptions),
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
    }

    queryUsers (input) {
        const siteIds =
            this.SiteService.getSitesByPrivileges([this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.PERFORMANCE_REVIEW_MANAGE], true)
                .map(site => site.id);

        const params = {
            roleCode: this.ROLE_CODE_ENUM.EMPLOYEE,
            name: input,
            'siteIds[]': siteIds
        };

        return this.UserResource.query(params).$promise;
    }

    queryManagers (input) {
        const siteIds =
            this.SiteService.getSitesByPrivileges([this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.PERFORMANCE_REVIEW_MANAGE], true)
                .map(site => site.id);

        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            name: input,
            'siteIds[]': siteIds
        };

        return this.UserResource.query(params).$promise;
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.selectedEmployee = null;
        this.selectedManager = null;

        this.initMultiFilter();
        this.submitFilter();
    }

    submitFilter () {
        this.filter['departmentIds[]'] = this.FilterService.departmentSelect.models
            .filter((department) => department.id !== null)
            .map((department) => department.id);

        this.filter['roleIds[]'] = this.FilterService.roleSelect.models
            .filter((role) => role.id !== null)
            .map(role => role.id);

        this.filter['levelIds[]'] = this.FilterService.levelSelect.models
            .filter((level) => level.id !== null)
            .map(level => level.id);

        this.filter['siteIds[]'] = this.multiFilter.siteSelect.models
            .filter((site) => site.value !== null)
            .map(site => site.value);

        this.filter['employeeStatuses[]'] = this.multiFilter.employeeStatusesSelect.models
            .filter((status) => status.value !== null)
            .map(status => status.value);

        this.list.fetch(this.filter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/filter/reviews/index.js